import { combineReducers } from '@reduxjs/toolkit';
import theme from '../../redux/customizer/themeSlice';
import navigation from '../../redux/auth/navigationSlice';

const themeReducer = combineReducers({
    theme,
    navigation
});

export default themeReducer;